const PALETTE = [
  "#2E86DE", // blue
  "#FF6B3D", // orange
  "#7C5CFC", // purple
  "#16A87E", // green
  "#D6336C", // pink
  "#F59F00", // amber
  "#0E9F6E", // teal
  "#4C6EF5", // indigo
]

export function colorForSource(name) {
  if (!name) return "#7C8697"
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]
}

export function initialsForSource(name) {
  if (!name) return "??"
  const parts = name.trim().split(/\s+/)
  return parts
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() || "")
    .join("")
}
